'use strict';

var React = require('react');
var text = require('../../../helpers/text.js');
require('../../../theme/breakpoints.js');
require('imask');
var useRefAndForward = require('../../../hooks/useRefAndForward.js');
require('resize-observer-polyfill');
var component = require('../../Button/component.js');
var index = require('../../Flex/index.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const FileInputTemplate = React.forwardRef(({ buttonLabel, buttonSize, filename, maxFilenameLength = 10, onFileChange, parserState, errored, ...props }, ref) => {
    const inputRef = useRefAndForward.useRefAndForward(null, ref);
    const maybeTruncatedFilename = text.truncate({ size: maxFilenameLength, indicator: '…' })(filename ?? '');
    const isFilenameTruncated = maybeTruncatedFilename !== filename;
    const defaultButtonLabel = filename ? 'Edit' : 'Upload';
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(index.Flex.Row, { space: "s", alignItems: "stretch" },
            React__default.default.createElement(component.Button, { disabled: props.disabled, size: buttonSize, onClick: () => inputRef.current?.click() }, buttonLabel ?? defaultButtonLabel),
            filename && (React__default.default.createElement(styles.Styled.FilenameContainer, { space: "s", justifyContent: "flex-start", alignItems: "center", errored: errored, disabled: props.disabled },
                React__default.default.createElement(styles.Styled.FilenameText, { disabled: props.disabled, variant: "caption", title: isFilenameTruncated ? filename : undefined }, maybeTruncatedFilename),
                !errored && parserState === 'pending' && (React__default.default.createElement(styles.Styled.LoadingIcon, { name: "wait-circle-outlined", "aria-label": "parsing" })),
                !errored && parserState === 'success' && (React__default.default.createElement(styles.Styled.ValidIcon, { name: "validate-circle-outlined", "aria-label": "parse success" })),
                !props.disabled && (errored || parserState === 'idle') && (React__default.default.createElement(styles.Styled.ClearIcon, { errored: errored, "aria-label": "clear", name: "clear-filled", onClick: () => onFileChange(null) }))))),
        React__default.default.createElement(styles.Styled.HiddenInput, { ...props, type: "file", ref: inputRef, onChange: event => onFileChange(event.target.files?.[0] ?? null) })));
});

exports.FileInputTemplate = FileInputTemplate;
//# sourceMappingURL=template.js.map
